import { FC } from 'react'
import { Controller, useFormContext } from 'react-hook-form'
import { useTranslation } from 'react-i18next'

import { cn } from '@bem-react/classname'

import { Field } from '@/components/Form/Field'
import { FieldPhone } from '@/components/Form/FieldPhone'
import { Button } from '@/components/UI/Button'
import Icon from '@/components/UI/Icon'
import { Tag } from '@/components/UI/Tag'

import { LoginModel } from '../../models/Login.model'
import './LoginStep.scss'

interface IEmailCodeStepProps {
  className?: string
  actions: 'email' | 'phone' | '2fa' | 'code'
  onSetActions: (actions: 'email' | 'phone') => void
}

const cnLoginStepStep = cn('LoginStep')

export const LoginStep: FC<IEmailCodeStepProps> = ({
  className,
  actions,
  onSetActions,
}) => {
  const { t } = useTranslation()

  const {
    control,
    register,
    formState: { errors },
  } = useFormContext<LoginModel>()

  return (
    <div className={cnLoginStepStep(null, [className])}>
      <Tag className={cnLoginStepStep('title')}>{t('login-title')}</Tag>

      <div className={cnLoginStepStep('tabs')}>
        <Button
          fluid
          color={actions === 'email' ? 'dark' : 'light'}
          onClick={() => onSetActions('email')}
        >
          {t('login-tab-email')}
        </Button>
        <Button
          fluid
          color={actions === 'phone' ? 'dark' : 'light'}
          onClick={() => onSetActions('phone')}
        >
          {t('login-tab-phone')}
        </Button>
      </div>

      {actions === 'email' ? (
        <Field
          iconLeft={
            <Icon
              name='email'
              stroke={
                errors.email?.message ? 'var(--badges-alerts-red)' : 'white'
              }
            />
          }
          placeholder={t('login-placeholder-email')}
          label={t('login-label-email')}
          mb='none'
          {...register('email')}
          errors={t(errors.email?.message ?? '')}
          required
        />
      ) : (
        <Controller
          name='phone'
          control={control}
          render={({ field: { onChange, value } }) => (
            <FieldPhone
              onChange={onChange}
              value={value}
              errors={t(errors.phone?.message ?? '')}
            />
          )}
        />
      )}
    </div>
  )
}
